module.exports = __webpack_public_path__ + "img/b-hair2.65e631b2.png";